import { render, staticRenderFns } from "./QuestionarioFinale.vue?vue&type=template&id=dcb628c6&scoped=true"
import script from "./QuestionarioFinale.vue?vue&type=script&lang=js"
export * from "./QuestionarioFinale.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioFinale.vue?vue&type=style&index=0&id=dcb628c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb628c6",
  null
  
)

export default component.exports